import config from '../configuration';

export let didCallPartnerVisit = false;

export async function logToPartnerVisit(page_type: string): Promise<void> {
  try {
    if (!config.partner?.partner_identifier) return;
    if (didCallPartnerVisit) return;
    didCallPartnerVisit = true;
    const partnerVisitUrl = `${config.urls.apiBaseUrl}/api/v1/partners/${config.partner?.partner_identifier}/widgets/partner_visit/`;
    const data = {
      page_type: page_type,
      origin_url: window.location.href
    };
    const result = await fetch(partnerVisitUrl, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (result.status === 200) {
      return;
    }
  } catch (err) {
    console.debug(`unable to log partner visit: ${err}`);
  }
  didCallPartnerVisit = false;
}

// using this function only for testing. since we cannot update didCallPartnerVisit directly when imported.
export function updateDidCallPartnerVisit(visited: boolean) {
  didCallPartnerVisit = visited;
}
